<div class="cmps-cdk-d-flex cmps-cdk-flex-wrap">
    <div
        class="cmps-cdk-flex-100 cmps-cdk-flex-xl-65 cmps-cdk-pr-xl-1dot5 cmps-cdk-mb-1dot5 cmps-cdk-mb-xl-0"
    >
        <cmps-card-next
            [collapsable]="true"
            #userSearchCard
        >
            <cmps-card-header-next>
                {{
                    _i18n._10011_USER_AND_EVALUATION_TYPE_SELECTION | translate
                }}
            </cmps-card-header-next>
            <cmps-card-body-next>
                <div
                    searchuser
                    [userId]="state?.selectedUser?.value?.id"
                    (select)="_onUserSelect($event)"
                    #userSearch
                    *ngIf="!state?.pending?.reload"
                ></div>
            </cmps-card-body-next>
        </cmps-card-next>
    </div>

    <div class="cmps-cdk-flex-100 cmps-cdk-flex-xl-35">
        <cmps-card-next
            [collapsable]="true"
            #templateVersionCard
        >
            <cmps-card-header-next>
                {{ _i18n._10012_SELECT_AN_EVALUATION_TYPE | translate }}
            </cmps-card-header-next>
            <cmps-card-body-next>
                <ng-container *ngIf="!state?.pending?.reload">
                    <select
                        class="cmps-form-input"
                        size="5"
                        [ngModel]="state?.selectedTemplateVersionId?.value"
                        #selectElement
                    >
                        <ng-container *ngFor="let v of state?.templateVersions">
                            <option [value]="v.templateVersionId">
                                {{ v.name }}
                            </option>
                        </ng-container>
                    </select>
                    <div class="cmps-eval-main--select-template-btn">
                        <button
                            cmpsButton
                            (click)="
                                _onSelectTemplateVersionClick(
                                    selectElement?.value
                                )
                            "
                        >
                            <span cmpsButtonLabel>{{
                                _i18n._10013_SELECT_EVALUATION | translate
                            }}</span>
                        </button>
                    </div>
                </ng-container>
            </cmps-card-body-next>
        </cmps-card-next>
    </div>
</div>

<router-outlet></router-outlet>
